<template>
  <ul class="card-property">
    <li
      v-for="(field, index) in fields"
      :key="`card-property-field-${index}`"
      class="card-property__field"
    >
      <span class="card-property__label">{{ field.label }}</span>
      {{ field.data }}
    </li>
    <HdButton v-if="isExposeAvailable" class="card-property__cta" @click="openExposeInNewTab()">
      {{ $t('DASHBOARD.CARD.EXPANDED.PROPERTY_DETAILS.CTA_LABEL') }}
    </HdButton>
  </ul>
</template>

<script>
import { HdButton } from 'homeday-blocks';
import { PROPERTY_TYPE } from '@/config/CONSTANTS';

export default {
  name: 'CardPropertyDetails',
  components: { HdButton },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    propertyTypeName() {
      const propertyType = this.deal.property.property_type;

      if (propertyType === PROPERTY_TYPE.COMMERCIAL) {
        return this.$t('WIZARD.BUILDING_TYPE.OPTIONS.COMMERCIAL');
      }

      if (propertyType === PROPERTY_TYPE.APARTMENT) {
        const apartmentType = this.deal.property.apartment_type;
        return apartmentType
          ? this.$t(`WIZARD.ACCESSIBILITY.APARTMENT_TYPES.${apartmentType.toUpperCase()}`)
          : this.$t('GENERAL.APARTMENT');
      }

      if (propertyType === PROPERTY_TYPE.HOUSE) {
        const buildingType = this.deal.property.building_type;
        return buildingType
          ? this.$t(`WIZARD.BUILDING_TYPE.OPTIONS.${buildingType.toUpperCase()}`)
          : this.$t('GENERAL.HOUSE');
      }

      if (propertyType === PROPERTY_TYPE.PLOT) {
        return this.$t('GENERAL.PLOT');
      }

      return null;
    },
    fields() {
      return [
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.PROPERTY_DETAILS.UID'),
          data: this.deal.uid,
        },
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.PROPERTY_DETAILS.PROPERTY_TYPE'),
          data: this.propertyTypeName,
        },
      ].filter((field) => field.data);
    },
    isExposeAvailable() {
      return this.deal.property.details.published_on_homeday_website;
    },
  },
  methods: {
    openExposeInNewTab() {
      window.open(`${process.env.VUE_APP_MY_HD}/expose/${this.deal.uid}`, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.card-property {
  &__field {
    @include font('DS-90');
    align-items: center;
    display: flex;
    gap: $sp-s - $sp-xxs;

    &:not(:last-child) {
      margin-bottom: $sp-s;

      @include for('tablet') {
        margin-bottom: $sp-m;
      }
    }

    @include for('tablet') {
      @include font('DS-100');
    }
  }

  &__label {
    font-weight: 700;
  }

  &__cta {
    align-items: center;
    background-color: getShade($secondary-color, 110);
    box-shadow: 0 3px 2px rgba(0, 0, 0, 0.12), 0 0 4px rgba(0, 0, 0, 0.24);
    color: $primary-bg;
    cursor: pointer;
    border-radius: $sp-xxs;
    display: flex;
    font-weight: 600;
    justify-content: center;
    line-height: $sp-l - $sp-s;
    margin-top: $sp-s;
    padding: $sp-s $sp-l;
    transition: box-shadow 0.3s;
    width: 100%;

    &:hover {
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
